import React, { useEffect, useState } from 'react';
import { Field, FieldProps, FormikProps } from 'formik';

// import { isPossiblePhoneNumber } from 'react-phone-number-input';
import {
  FieldRow,
  // Flex,
  // FormikUploaderOther,
  StyledFormGroup,
  StyledFormSelectFormik,
  StyledFormikDatePicker,
  // WrappedQuery,
} from '../../../../components/shared';
import // formatSelectValue,
// isEmpty,
'../../../../utils';
import { CaregiverType, Option, PeopleProfileInstitutionFormType } from '../../../../utils/types';
import { InstitutionsCard } from './institutionsCard';
// import { PeopleProfileInstitutionCard } from './peopleProfileInstitutionCard';
import { ALL_DISABILITY_TYPES } from '../../../../graphql/queries/AllDisabilityTypes';
import { CaregiversCard } from './caregiversCard';
import { getAllDisabilityTypes } from '../../../../utils/idbFns';
import { client } from '../../../../apollo';
import { PersonDetailsFormType } from '../forms/PersonDetailsForm';

export type FormType = PersonDetailsFormType & {
  typeId: Option | undefined;
  portal: string;

  careGiverContactNumber: string;
  careGiverEmailAddress: string;
  careGiverEmployer: string;
  careGiverGender: Option | undefined;
  careGiverMaritalStatus: Option | undefined;
  careGiverName: string;
  careGiverNationalId: string;
  careGiverOccupation: Option | undefined;
  careGiverPhysicalAddress: string;
  careGiverRelationship: Option | undefined;
  careGiverSurname: string;
  careGiverType: Option | undefined;
  dateExited: Date | null;
  disability: Option | undefined;
  disabilityTypeIds: Option[] | undefined;
  districtId: Option | undefined;
  emailAddress: string;
  emisNumber: number | undefined;
  gradeIds: Option[];
  ovc: Option | undefined;
  prePrimaryExperience: boolean;
  trackingId: string;
  yearsInGrade: number | null;
  yearsInPhase: number | null;

  primaryInstitutionId: Option | undefined;
  institutionIds: Option[];
  additionalInstitution: boolean;
  associatedInstitutions: PeopleProfileInstitutionFormType[];

  immunizationCard: Option | undefined;
  receivingSocialGrant: Option | undefined;
  accountPayer: Option | undefined;
  childResidesWithThisCaregive: Option | undefined;
  grantType: Option | undefined;
  dateStarted: Date | null;

  proofOfIncomeFile: string | undefined;
  roadToHealthCardFile: string | undefined;
  monthlyIncomeRange: Option | undefined;
  monthlyIncome: number | undefined;
  incomeSourceDocument: Option | undefined;
  caregiverIdentificationType: Option | undefined;
  caregiverCitizenshipId: Option | undefined;
  caregiverPassport: string;
  employmentStatus: Option | undefined;
  reasonExited: string;
  caregiver: CaregiverType;
  caregiverList: CaregiverType[];
};

type Props = {
  formikProps: FormikProps<any>;
  userRoles?: any;
  institution?: any;
  allNationalities: any;
  allGender: any;
};

const GRANT_TYPES = [
  { label: 'Child Support', value: 'Child Support' },
  { label: 'Foster Child', value: 'Foster Child' },
  { label: 'Care-Dependency', value: 'Care-Dependency' },
];

// const validate = (value: any, label: any) => {
//   let error;

//   if (isEmpty(value) && !value) {
//     error = `${label} is required.`;
//   }

//   return error;
// };

/* These functions are not required for now */

// const validateContactNumber = (value: any) => {
//   let error;
//   if (value && !isPossiblePhoneNumber(value)) {
//     error = 'Phone number must be valid';
//   }
//   return error;
// };

// const validateRequiredContactNumber = (value: any) => {
//   let error;

//   const isNotValidString = validateContactNumber(value);

//   if (isNotValidString) {
//     error = isNotValidString;
//   }

//   if (isEmpty(value) && (!value || value === '')) {
//     error = `Contact Number is required.`;
//   }

//   return error;
// };

const FieldsForLearner: React.FC<Props> = props => {
  const { formikProps, userRoles } = props;
  const [disabilityTypes, setDisabilityTypes] = useState<any[]>([]);

  const fetchNationalities = async () => {
    try {
      const {
        data: { disabilityTypes },
      }: any = await client.query({
        query: ALL_DISABILITY_TYPES,
        variables: { input: {} },
      });

      if (disabilityTypes) {
        const result = disabilityTypes.map((a: any) => ({ label: a.name, value: a.id }));
        setDisabilityTypes(result);
      }
    } catch (error) {
      const result = await getAllDisabilityTypes();
      const allDisabilityTypes = result.map((a: any) => ({ label: a.name, value: a.id }));
      setDisabilityTypes(allDisabilityTypes);
    }
  };

  /* This is not ready for use yet.  */
  // const [showUploadRoadToHealthCardModal, setShowUploadRoadToHealthCardModal] = useState(false);

  /* This is not ready for use yet.  */
  // const [roadToHealthCardFile, setRoadToHealthCardFile] = useState<{
  //   id?: string;
  //   name?: string;
  // }>({});

  /* This is not ready for use yet.  */
  // const [roadToHealthCardFileExists, setRoadToHealthCardFileExists] = useState<string>('');

  const canLinkInstitutions = ['INSTITUTION_ADMIN', 'INSTITUTION_MEMBER'].some(
    (item: any) => userRoles && userRoles.includes(item)
  );

  /* This is not ready for use yet.  */
  // const {
  //   data: roadToHealthCardFileData,
  //   error: roadToHealthCardFileError,
  //   loading: roadToHealthCardFileLoading,
  // } = useQuery(GET_FILE, {
  //   skip: !formikProps.values.roadToHealthCardFile,
  //   variables: {
  //     id: formikProps.values.roadToHealthCardFile,
  //   },
  // });

  /* This is not ready for use yet.  */
  // useEffect(() => {
  //   if (roadToHealthCardFileData && roadToHealthCardFileData.file && roadToHealthCardFileData.file.name) {
  //     setRoadToHealthCardFileExists(roadToHealthCardFileData.file.name);
  //   }
  // }, [roadToHealthCardFileData]);

  React.useEffect(() => {
    if (!props.institution) {
      const primaryInstitution =
        formikProps.values && formikProps.values.associatedInstitutions.find((a: any) => a.primary);

      if (primaryInstitution && primaryInstitution.trackingId) {
        formikProps.setFieldValue('trackingId', primaryInstitution.trackingId);
      }
    } else {
      const primaryInstitution =
        formikProps.values &&
        formikProps.values.associatedInstitutions.find(
          (a: any) => a.institution && a.institution.id === props.institution.id
        );

      if (primaryInstitution && primaryInstitution.trackingId) {
        formikProps.setFieldValue('trackingId', primaryInstitution.trackingId);
      }
    }
  }, []);

  useEffect(() => {
    fetchNationalities();
  }, []);

  return (
    <React.Fragment>
      {/* This is not ready for use yet.  */}
      {/* <Modal
        open={showUploadRoadToHealthCardModal}
        onClose={() => {
          setRoadToHealthCardFile({});
          setShowUploadRoadToHealthCardModal(!showUploadRoadToHealthCardModal);
        }}
        heading={`Manage File: ${roadToHealthCardFile.name}`}
      >
        <FileForm
          file={roadToHealthCardFile}
          refetchQueryFunction={() => {
            return [
              {
                query: GET_FILE,
                variables: {
                  id: formikProps.values.roadToHealthCardFile,
                },
              },
            ];
          }}
          onDone={() => {
            setRoadToHealthCardFile({});
            setShowUploadRoadToHealthCardModal(!showUploadRoadToHealthCardModal);
          }}
          onDelete={() => {
            setRoadToHealthCardFileExists('');
          }}
        />
      </Modal> */}
      <FieldRow>
        <Field
          name="immunizationCard"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormSelectFormik
              {...field}
              field={field}
              label="Road to Health Card"
              form={formikProps}
              options={[
                {
                  label: 'Yes',
                  value: true,
                },
                {
                  label: 'No',
                  value: false,
                },
              ]}
              mr={4}
            />
          )}
          // {...values.typeId &&
          //   values.typeId.label === 'Learners' && {
          //     validate: (value: any) => validate(value, 'Identification Type'),
          //   }}
        />
        {formikProps.values.immunizationCard && formikProps.values.immunizationCard.label === 'No' && (
          <Field
            name="reasonForLackOfRoadToHealthCard"
            render={({ field }: FieldProps<FormType>) => (
              <StyledFormGroup
                {...field}
                field={field}
                form={formikProps}
                label="Reason for Lack of Road to Health Card"
                mr={4}
              />
            )}
          />
        )}

        {/* This is not ready for use yet.  */}

        {/* {formikProps.values.immunizationCard && formikProps.values.immunizationCard.value && (
            <Field
              name="roadToHealthCardFile"
              render={({ field }: FieldProps<FormType>) => (
                <Fragment>
                  {uploadError ? <ErrorComponent message={uploadError} /> : null}

                  {formikProps.values.roadToHealthCardFile && (
                    <Fragment>
                      {!roadToHealthCardFileLoading && !roadToHealthCardFileError && roadToHealthCardFileExists && (
                        <Fragment>
                          <Button
                            bg="success"
                            icon={<File />}
                            isIcon={true}
                            mr={1}
                            p={0}
                            type="button"
                            text="Download File"
                            width="40px"
                            style={{ fontSize: '10px', marginTop: '24px' }}
                            onClick={() => {
                              setRoadToHealthCardFile(roadToHealthCardFileData.file);
                              setShowUploadRoadToHealthCardModal(!showUploadRoadToHealthCardModal);
                            }}
                          />
                          <div style={{ marginTop: '24px', marginRight: '35px' }}>
                            {roadToHealthCardFileData &&
                              roadToHealthCardFileData.file &&
                              roadToHealthCardFileData.file.name}
                          </div>
                        </Fragment>
                      )}
                    </Fragment>
                  )}

                  <Button
                    type="button"
                    id="uppy1-open"
                    text="Upload Road to Health Card"
                    hidden={!!roadToHealthCardFileExists}
                    width="50px"
                    mr={4}
                    icon={<UploadCloud size={10} color="white" />}
                    style={{ fontSize: '10px', marginTop: '24px' }}
                  />

                  <FormikUploaderOther
                    onComplete={onComplete}
                    setUploadError={setUploadError}
                    uploadError={uploadError}
                    client={client}
                    {...field}
                    field={field}
                    form={formikProps}
                  />
                </Fragment>
              )}
            />
          )} */}
        <Field
          name="disability"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormSelectFormik
              {...field}
              field={field}
              label="Disability"
              form={formikProps}
              options={[
                {
                  label: 'Yes',
                  value: true,
                },
                {
                  label: 'No',
                  value: false,
                },
              ]}
              // mr={4}
            />
          )}
        />
        {formikProps.values.disability && formikProps.values.disability.value && (
          <Field
            name="disabilityTypeIds"
            render={({ field }: FieldProps<FormType>) => (
              <StyledFormSelectFormik
                {...field}
                field={field}
                label="Disability Type(s)"
                form={formikProps}
                ml={4}
                isMulti={true}
                options={disabilityTypes}
              />
            )}
          />
        )}
      </FieldRow>
      <FieldRow>
        <FieldRow flex={2.5}>
          <Field
            name="specialNeeds"
            render={({ field }: FieldProps<FormType>) => (
              <StyledFormGroup {...field} field={field} form={formikProps} label="Special Needs" mr={4} />
            )}
          />
        </FieldRow>
        <Field
          name="ovc"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormSelectFormik
              {...field}
              field={field}
              label="Orphaned / Vulnerable Child"
              form={formikProps}
              options={[
                {
                  label: 'Yes',
                  value: true,
                },
                {
                  label: 'No',
                  value: false,
                },
              ]}
              mr={4}
            />
          )}
        />
        <Field
          name="receivingSocialGrant"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormSelectFormik
              {...field}
              field={field}
              label="Receiving Social Grant"
              form={formikProps}
              options={[
                {
                  label: 'Yes',
                  value: true,
                },
                {
                  label: 'No',
                  value: false,
                },
              ]}
              // ml={4}
              mr={4}
            />
          )}
        />
        {formikProps.values.receivingSocialGrant && formikProps.values.receivingSocialGrant.value && (
          <Field
            name="grantType"
            render={({ field }: FieldProps<FormType>) => (
              <StyledFormSelectFormik
                {...field}
                field={field}
                label="Grant Type"
                form={formikProps}
                options={GRANT_TYPES}
                // mr={4}
              />
            )}
          />
        )}
      </FieldRow>

      <FieldRow>
        <FieldRow flex={0.5}>
          <Field
            name="trackingId"
            render={({ field }: FieldProps<FormType>) => (
              <StyledFormGroup
                {...field}
                field={field}
                form={formikProps}
                label="Tracking ID / Admission Number"
                mr={4}
              />
            )}
          />
        </FieldRow>
        {props.institution && (
          <>
            <FieldRow flex={0.33}>
              <Field
                name="dateStarted"
                render={() => (
                  <StyledFormikDatePicker
                    isSingleDate={true}
                    form={formikProps}
                    label="Registration Date"
                    dateLabel="dateStarted"
                    date={formikProps.values.dateStarted}
                    clearIcon={null}
                    format={'d-M-yyyy'}
                    mr={4}
                  />
                )}
                // validate={(value: any) => validate(value, 'Registration Date')}
              />
            </FieldRow>

            <FieldRow flex={0.33}>
              <Field
                render={() => (
                  <StyledFormikDatePicker
                    isSingleDate={true}
                    form={formikProps}
                    label="Date Exited"
                    dateLabel="dateExited"
                    date={formikProps.values.dateExited}
                    clearIcon={null}
                    format={'d-M-yyyy'}
                  />
                )}
              />
            </FieldRow>
            {formikProps.values.dateExited && (
              <FieldRow flex={0.33}>
                <Field
                  name="reasonExited"
                  render={({ field }: FieldProps<FormType>) => (
                    <StyledFormGroup {...field} field={field} form={formikProps} label="Reason Exited" ml={4} />
                  )}
                />
              </FieldRow>
            )}
          </>
        )}
      </FieldRow>
      {!props.institution ? (
        <InstitutionsCard
          isLeaner={true}
          formikProps={formikProps}
          viewMode={formikProps.values.portal !== 'admin' && !canLinkInstitutions}
          currentInstitutionsOnly={formikProps.values.portal !== 'admin' && !canLinkInstitutions}
        />
      ) : null

      /* The use case for this component is not ready */

      // <PeopleProfileInstitutionCard
      //   isLeaner={true}
      //   formikProps={formikProps}
      //   viewMode={formikProps.values.portal !== 'admin' && !canLinkInstitutions}
      //   currentInstitutionsOnly={formikProps.values.portal !== 'admin' && !canLinkInstitutions}
      //   institution={props.institution}
      // />
      }
      <CaregiversCard
        formikProps={formikProps}
        allGender={props.allGender}
        allNationalities={props.allNationalities}
        // viewMode={formikProps.values.portal !== 'admin' && !canLinkInstitutions}
        // currentInstitutionsOnly={formikProps.values.portal !== 'admin' && !canLinkInstitutions}
      />
    </React.Fragment>
  );
};

export default FieldsForLearner;
